import { Link } from "react-router-dom";
import logo from "@/assets/logo.svg";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src={logo} alt="" aria-hidden="true" className={`${className} select-none`} draggable="false" />
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display text-[1.25rem] font-bold leading-none tracking-tight text-[var(--ink)] ${className}`}>
    Hunters<span className="text-[var(--sage)]">Mapp</span>
  </span>
);

export const Logo = ({ href = "/", markClass = "h-9 w-9", testId = "logo-link" }) => (
  <Link to={href} data-testid={testId} className="inline-flex items-center gap-3">
    <LogoMark className={markClass} />
    <Wordmark />
  </Link>
);
